module.exports = __webpack_public_path__ + "static/img/h_2_15.8c5294a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/h_2_15.png
// module id = U+dE
// module chunks = 0